/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipo di una transazione voucher POS
 */
export enum TipoTransazioneVoucher {

    PRENOTAZIONE = 'PRENOTAZIONE',

    REGOLARE = 'REGOLARE',

    ERRATA_CORRIGE = 'ERRATA_CORRIGE',

    ANNULLATA = 'ANNULLATA'
}

